export default __webpack_public_path__ + "static/media/quiz.9d61a4c0.svg";